import { Box, Stack, TextField, Typography } from '@mui/material'
import Address from '../CompanySettings/Address'
import CompanyLogo from '../CompanySettings/CompanyLogo'
import LogoColor from '../CompanySettings/LogoColor'
import { useState } from 'react'

const CompanyStep = ({ companySettings, setCompanySettings }) => {
  const [replyToEmailError, setReplyToEmailError] = useState(false)
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

  return (
    <Stack gap={1}>
      <Typography variant="h6" gutterBottom>
        Tell us about your company
      </Typography>

      <TextField
        label="Company Name"
        fullWidth
        value={companySettings?.orgName ?? ''}
        onChange={(e) =>
          setCompanySettings((prev) => ({ ...prev, orgName: e.target.value }))
        }
        required
      />
      <TextField
        label="Short Name"
        fullWidth
        value={companySettings?.orgShortName ?? ''}
        helperText="Used for SMS, etc."
        onChange={(e) => {
          const value = e.target.value.toUpperCase().replace(/[^A-Z]/g, '')
          setCompanySettings((prev) => ({
            ...prev,
            orgShortName: value,
          }))
        }}
        autoComplete="off"
        required
      />
      <TextField
        label="Company Website"
        fullWidth
        value={companySettings?.publicWebsite ?? ''}
        onChange={(e) =>
          setCompanySettings((prev) => ({
            ...prev,
            publicWebsite: e.target.value,
          }))
        }
        helperText="Your public website URL"
        autoComplete="none"
      />

      <TextField
        label="Reply To Email"
        fullWidth
        required
        value={companySettings?.replyToEmail ?? ''}
        helperText="What email should replies from system messages (i.e. Shift Assignment or Reference Requests) get sent to?"
        onChange={(e) => {
          setReplyToEmailError(false)
          const value = e.target.value
          setCompanySettings((prev) => ({
            ...prev,
            replyToEmail: value,
          }))
          if (!emailRegex.test(value)) {
            setReplyToEmailError(true)
          }
        }}
        error={replyToEmailError}
        autoComplete="off"
      />
      <Address
        companySettings={companySettings}
        setCompanySettings={setCompanySettings}
      />
      <CompanyLogo
        existingLogo={companySettings?.logo}
        onChange={(newLogo) =>
          setCompanySettings((prev) => ({ ...prev, logo: newLogo }))
        }
      />
      <LogoColor
        companySettings={companySettings}
        setCompanySettings={setCompanySettings}
      />
    </Stack>
  )
}

export default CompanyStep
